class SectionNavigation extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this?.els?.current?.exists) {
      this.els.current.element.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      })
    }
  }
}

if (!customElements.get('section-navigation')) {
  customElements.define('section-navigation', SectionNavigation)
}
